/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { Injectable } from '@angular/core';
import { FacHttpClientService, FacDropDownSearchResponse } from '@foglight/angular-common';
import { Observable, Subject } from 'rxjs';
import { downloadsEndpoint, globalSearchEndpoint, productEndpoint, userEndpoint } from 'src/app/shared/constants';

@Injectable()
export class FacNavbarService {
  userSelectedTheme$ = new Subject<string>();

  constructor(private httpClient: FacHttpClientService) {}

  getGlobalSearchResult(
    searchKey: string,
    maxResults: number = 100
  ): Observable<FacDropDownSearchResponse> {
    return this.httpClient.post<FacDropDownSearchResponse>(
      globalSearchEndpoint,
      {
        searchKey,
        maxResults,
      }
    );
  }

  updateServerInstanceName(name: string): Observable<any> {
    return this.httpClient.patch(productEndpoint, {
      serverInstance: {
        name: name,
      },
    });
  }

  getListofDownloadableFglams(): Observable<any> {
    return this.httpClient.get(downloadsEndpoint);
  }

  setUserSelectedTheme(selectedTheme: string): Observable<any> {
    return this.httpClient.patch(userEndpoint, {
      userSettings: {
        themes: {
          main: selectedTheme,
        },
      },
    });
  }
}
